import { css } from 'styled-components'

import { defineFont, Font, FontStyles, FontWeights } from '../utils/FontUtils'

export const fontFamilies = {
  regular: '"BB Regular", sans-serif',
  cond: '"BB Cond", sans-serif',
  condBold: '"BB Cond Bold", sans-serif',
} as const

enum FontKeys {
  BBRegular = 'BBRegular',
  BBCond = 'BBCond',
  BBCondBold = 'BBCondBold',
}

export const declarations: { [key in FontKeys]: Font } = {
  BBRegular: {
    fontFamily: 'BB Regular',
    fontWeight: FontWeights.regular,
    fontStyle: FontStyles.normal,
    fallback: 'sans-serif',
    src: '/fonts/BbComputer/BB-Regular.ttf',
    srcFormat: 'truetype',
  },
  BBCond: {
    fontFamily: 'BB Cond',
    fontWeight: FontWeights.regular,
    fontStyle: FontStyles.normal,
    fallback: 'sans-serif',
    src: '/fonts/BbComputer/BB-Cond.ttf',
    srcFormat: 'truetype',
  },
  BBCondBold: {
    fontFamily: 'BB Cond Bold',
    fontWeight: FontWeights.regular,
    fontStyle: FontStyles.normal,
    fallback: 'sans-serif',
    src: '/fonts/BbComputer/BB-CondBold.ttf',
    srcFormat: 'truetype',
  },
}

export const fontsFaces = Object.values(declarations).map(
  (declaration) => css`
    @font-face {
      font-family: ${declaration.fontFamily};
      font-style: normal;
      font-display: swap;
      font-weight: ${declaration.fontWeight};
      src: url('${declaration.src}') format('truetype');
    }
  `
)

const fonts: { [key in FontKeys]: string } = {
  BBRegular: defineFont(declarations.BBRegular),
  BBCond: defineFont(declarations.BBCond),
  BBCondBold: defineFont(declarations.BBCondBold),
}

export default fonts
